import $ from 'jquery';

const visibleClass = 'js-password-visible';

$(document).on('click', '.password-widget .icon', (ev) => {
  ev.preventDefault();
  const $widget = $(ev.currentTarget).closest('.password-widget');
  const $field = $widget.find('input');

  if ($widget.hasClass(visibleClass)) {
    $widget.removeClass(visibleClass);
    $field.attr('type', 'password');
  } else {
    $widget.addClass(visibleClass);
    $field.attr('type', 'text');
  }

  $field.closest('form').on('submit', () => {
    $field.attr('type', 'password');
  });
});
